'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
export default class ResultHeader extends Component {
  render() {
    const {
      localizedTextKey
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "result-header",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${localizedTextKey}.header`
      })
    });
  }

}
ResultHeader.propTypes = {
  localizedTextKey: PropTypes.string
};